import Nullstack from 'nullstack';
export default function IconReplace({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-replace",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("rect", {
    x: "3",
    y: "3",
    width: "6",
    height: "6",
    rx: "1"
  }), "   ", Nullstack.element("rect", {
    x: "15",
    y: "15",
    width: "6",
    height: "6",
    rx: "1"
  }), "   ", Nullstack.element("path", {
    d: "M21 11v-3a2 2 0 0 0 -2 -2h-6l3 3m0 -6l-3 3"
  }), "   ", Nullstack.element("path", {
    d: "M3 13v3a2 2 0 0 0 2 2h6l-3 -3m0 6l3 -3"
  }), " ");
}